import { Box, CircularProgress, Typography } from "@material-ui/core";
import { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useAppState } from "../../components/AppProvider/AppProvider";
import { fetchInitialData } from "../../helpers/fetchers";

const SsoCallbackPage = () => {
  const [ctx, dispatch] = useAppState() ?? [];
  const history = useHistory();
  const location = useLocation();
  const [message, setMessage] = useState("Menyelesaikan login SSO...");

  useEffect(() => {
    (async () => {
      const params = new URLSearchParams(location.search);
      const error = params.get("error");
      const ticket = params.get("ticket");

      if (error) {
        setMessage(error);
        return;
      }

      if (!ticket) {
        setMessage("Ticket SSO tidak ditemukan.");
        return;
      }

      try {
        const resp = await fetch(`${ctx?.baseUrl}/sso/exchange?ticket=${encodeURIComponent(ticket)}`);
        const data = await resp.json();
        if (resp.status !== 200 || !data.token) {
          throw new Error(data.error ?? "Ticket SSO tidak valid.");
        }

        localStorage.setItem("apiKey", data.token);

        const { departments, roles } = await fetchInitialData(
          ctx?.baseUrl ?? "",
          data.token
        );

        dispatch?.({ type: "apiKey", data: data.token });
        dispatch?.({ type: "loggedIn", data: true });
        dispatch?.({ type: "departments", data: departments });
        dispatch?.({ type: "roles", data: roles });
        history.replace("/");
      } catch (e) {
        setMessage(e instanceof Error ? e.message : String(e));
      }
    })();
  }, [ctx?.baseUrl, dispatch, history, location.search]);

  return (
    <Box height="100vh" display="flex" alignItems="center" justifyContent="center" flexDirection="column">
      <CircularProgress />
      <Box mt={2}>
        <Typography>{message}</Typography>
      </Box>
    </Box>
  );
};

export default SsoCallbackPage;
